/** Default copy (en/fr/es) for the "In Our DNA" careers section in `./InOurDNA.tsx`. */
import { LanguageContent } from "@components/Shared/model/LanguageContent";
import { InOurDNAContentProps } from "./InOurDNA";

/**
 * Two cards: Training & Development and Ryerson Gives Back. `./InOurDNA.tsx` uses it when no
 * `content` is passed, and the careers pages that rely on it read `title` from it as the
 * `AllSections` section title (and so its anchor id).
 */
export const InOurDNAContent: LanguageContent<InOurDNAContentProps> = {
	en: {
		title: "In Our DNA",
		cards: [
			{
				title: "Training & Development",
				context:
					"At Ryerson, opportunities to grow and support for professional advancement are abundant through a broad range of training and educational opportunities.",
				backgroundUrl: "/images/ryerson-academy/TrainingAndDevelopment.jpg",
				link: "/about-us/careers/working-at-ryerson/training-and-development",
			},
			{
				title: "Ryerson Gives Back",
				context:
					"Ryerson invests in the community and our people in a variety of ways, from volunteerism to providing educational resources to help our employees and families advance their careers.",
				backgroundUrl: "/images/training-and-development/RGBUpdate.jpg",
				link: "/why-ryerson/ryerson-commitment/ryerson-gives-back",
			},
		],
	},
	fr: {
		title: "C’est dans notre ADN",
		cards: [
			{
				title: "Formation et développement",
				context:
					"Chez Ryerson, profitez d’un abondant soutien au développement professionnel et de plusieurs occasions pour grandir grâce à notre large éventail de possibilités de formation et d’éducation",
				backgroundUrl: "/images/ryerson-academy/TrainingAndDevelopment.jpg",
				link: "/about-us/careers/working-at-ryerson/training-and-development",
			},
			{
				title: "Communauté Ryerson Gives Back",
				context:
					"Ryerson investit dans la communauté et dans son personnel de diverses manières, du bénévolat à la fourniture de ressources éducatives, afin d’aider ses employés et leur famille à faire progresser leur carrière.",
				backgroundUrl: "/images/training-and-development/RGBUpdate.jpg",
				link: "/why-ryerson/ryerson-commitment/ryerson-gives-back",
			},
		],
	},
	es: {
		title: "En nuestro ADN",
		cards: [
			{
				title: "Capacitación y desarrollo",
				context:
					"En Ryerson, las oportunidades de crecer y el apoyo para el progreso profesional son abundantes a través de una amplia gama de oportunidades de capacitación y educación.",
				backgroundUrl: "/images/ryerson-academy/TrainingAndDevelopment.jpg",
				link: "/about-us/careers/working-at-ryerson/training-and-development",
			},
			{
				title: "Ryerson devuelve",
				context:
					"Ryerson invierte en la comunidad y en nuestra gente en muchas formas, desde el voluntariado hasta el proporcionar recursos educativos para ayudar a nuestros empleados y familias a crecer en sus carreras.",
				backgroundUrl: "/images/training-and-development/RGBUpdate.jpg",
				link: "/why-ryerson/ryerson-commitment/ryerson-gives-back",
			},
		],
	},
};
